/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as UnauthImport } from './routes/_unauth'
import { Route as AuthImport } from './routes/_auth'
import { Route as AuthIndexImport } from './routes/_auth/index'
import { Route as UnauthResetPasswordImport } from './routes/_unauth/reset-password'
import { Route as UnauthPrivacyPolicyImport } from './routes/_unauth/privacy-policy'
import { Route as UnauthLoginImport } from './routes/_unauth/login'
import { Route as UnauthForgotPasswordImport } from './routes/_unauth/forgot-password'
import { Route as UnauthCreatePasswordImport } from './routes/_unauth/create-password'
import { Route as AuthProjectSelectImport } from './routes/_auth/project-select'
import { Route as AuthOnlyofficeImport } from './routes/_auth/onlyoffice'
import { Route as AuthAllUsersImport } from './routes/_auth/all-users'
import { Route as AuthWithProjectImport } from './routes/_auth/_withProject'
import { Route as AuthWithProjectUsersImport } from './routes/_auth/_withProject/users'
import { Route as AuthWithProjectShiftsImport } from './routes/_auth/_withProject/shifts'
import { Route as AuthWithProjectShiftReportsImport } from './routes/_auth/_withProject/shift-reports'
import { Route as AuthWithProjectScorecardLogsImport } from './routes/_auth/_withProject/scorecard-logs'
import { Route as AuthWithProjectScorecardImport } from './routes/_auth/_withProject/scorecard'
import { Route as AuthWithProjectRolesHistoryImport } from './routes/_auth/_withProject/roles-history'
import { Route as AuthWithProjectRolesImport } from './routes/_auth/_withProject/roles'
import { Route as AuthWithProjectRequestModuleImport } from './routes/_auth/_withProject/request-module'
import { Route as AuthWithProjectReportDetailImport } from './routes/_auth/_withProject/reportDetail'
import { Route as AuthWithProjectProjectsImport } from './routes/_auth/_withProject/projects'
import { Route as AuthWithProjectProjectDocumentsImport } from './routes/_auth/_withProject/project-documents'
import { Route as AuthWithProjectPositionsImport } from './routes/_auth/_withProject/positions'
import { Route as AuthWithProjectPayrollSlipImport } from './routes/_auth/_withProject/payroll-slip'
import { Route as AuthWithProjectPatrolRoutesImport } from './routes/_auth/_withProject/patrol-routes'
import { Route as AuthWithProjectPatrolReportImport } from './routes/_auth/_withProject/patrol-report'
import { Route as AuthWithProjectPatrolPlansImport } from './routes/_auth/_withProject/patrol-plans'
import { Route as AuthWithProjectNoPermissionsImport } from './routes/_auth/_withProject/no-permissions'
import { Route as AuthWithProjectLoginHistoryImport } from './routes/_auth/_withProject/login-history'
import { Route as AuthWithProjectInstructionsImport } from './routes/_auth/_withProject/instructions'
import { Route as AuthWithProjectDepartmentsImport } from './routes/_auth/_withProject/departments'
import { Route as AuthWithProjectCompletedPatrolsImport } from './routes/_auth/_withProject/completed-patrols'
import { Route as AuthWithProjectProjectDetailProjectIdImport } from './routes/_auth/_withProject/project-detail.$projectId'
import { Route as AuthWithProjectDocumentsSplatImport } from './routes/_auth/_withProject/documents.$'

// Create/Update Routes

const UnauthRoute = UnauthImport.update({
  id: '/_unauth',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const AuthIndexRoute = AuthIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)

const UnauthResetPasswordRoute = UnauthResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => UnauthRoute,
} as any)

const UnauthPrivacyPolicyRoute = UnauthPrivacyPolicyImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => UnauthRoute,
} as any)

const UnauthLoginRoute = UnauthLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => UnauthRoute,
} as any)

const UnauthForgotPasswordRoute = UnauthForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => UnauthRoute,
} as any)

const UnauthCreatePasswordRoute = UnauthCreatePasswordImport.update({
  id: '/create-password',
  path: '/create-password',
  getParentRoute: () => UnauthRoute,
} as any)

const AuthProjectSelectRoute = AuthProjectSelectImport.update({
  id: '/project-select',
  path: '/project-select',
  getParentRoute: () => AuthRoute,
} as any)

const AuthOnlyofficeRoute = AuthOnlyofficeImport.update({
  id: '/onlyoffice',
  path: '/onlyoffice',
  getParentRoute: () => AuthRoute,
} as any)

const AuthAllUsersRoute = AuthAllUsersImport.update({
  id: '/all-users',
  path: '/all-users',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWithProjectRoute = AuthWithProjectImport.update({
  id: '/_withProject',
  getParentRoute: () => AuthRoute,
} as any)

const AuthWithProjectUsersRoute = AuthWithProjectUsersImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthWithProjectRoute,
} as any)

const AuthWithProjectShiftsRoute = AuthWithProjectShiftsImport.update({
  id: '/shifts',
  path: '/shifts',
  getParentRoute: () => AuthWithProjectRoute,
} as any)

const AuthWithProjectShiftReportsRoute =
  AuthWithProjectShiftReportsImport.update({
    id: '/shift-reports',
    path: '/shift-reports',
    getParentRoute: () => AuthWithProjectRoute,
  } as any)

const AuthWithProjectScorecardLogsRoute =
  AuthWithProjectScorecardLogsImport.update({
    id: '/scorecard-logs',
    path: '/scorecard-logs',
    getParentRoute: () => AuthWithProjectRoute,
  } as any)

const AuthWithProjectScorecardRoute = AuthWithProjectScorecardImport.update({
  id: '/scorecard',
  path: '/scorecard',
  getParentRoute: () => AuthWithProjectRoute,
} as any)

const AuthWithProjectRolesHistoryRoute =
  AuthWithProjectRolesHistoryImport.update({
    id: '/roles-history',
    path: '/roles-history',
    getParentRoute: () => AuthWithProjectRoute,
  } as any)

const AuthWithProjectRolesRoute = AuthWithProjectRolesImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AuthWithProjectRoute,
} as any)

const AuthWithProjectRequestModuleRoute =
  AuthWithProjectRequestModuleImport.update({
    id: '/request-module',
    path: '/request-module',
    getParentRoute: () => AuthWithProjectRoute,
  } as any)

const AuthWithProjectReportDetailRoute =
  AuthWithProjectReportDetailImport.update({
    id: '/reportDetail',
    path: '/reportDetail',
    getParentRoute: () => AuthWithProjectRoute,
  } as any)

const AuthWithProjectProjectsRoute = AuthWithProjectProjectsImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AuthWithProjectRoute,
} as any)

const AuthWithProjectProjectDocumentsRoute =
  AuthWithProjectProjectDocumentsImport.update({
    id: '/project-documents',
    path: '/project-documents',
    getParentRoute: () => AuthWithProjectRoute,
  } as any)

const AuthWithProjectPositionsRoute = AuthWithProjectPositionsImport.update({
  id: '/positions',
  path: '/positions',
  getParentRoute: () => AuthWithProjectRoute,
} as any)

const AuthWithProjectPayrollSlipRoute = AuthWithProjectPayrollSlipImport.update(
  {
    id: '/payroll-slip',
    path: '/payroll-slip',
    getParentRoute: () => AuthWithProjectRoute,
  } as any,
)

const AuthWithProjectPatrolRoutesRoute =
  AuthWithProjectPatrolRoutesImport.update({
    id: '/patrol-routes',
    path: '/patrol-routes',
    getParentRoute: () => AuthWithProjectRoute,
  } as any)

const AuthWithProjectPatrolReportRoute =
  AuthWithProjectPatrolReportImport.update({
    id: '/patrol-report',
    path: '/patrol-report',
    getParentRoute: () => AuthWithProjectRoute,
  } as any)

const AuthWithProjectPatrolPlansRoute = AuthWithProjectPatrolPlansImport.update(
  {
    id: '/patrol-plans',
    path: '/patrol-plans',
    getParentRoute: () => AuthWithProjectRoute,
  } as any,
)

const AuthWithProjectNoPermissionsRoute =
  AuthWithProjectNoPermissionsImport.update({
    id: '/no-permissions',
    path: '/no-permissions',
    getParentRoute: () => AuthWithProjectRoute,
  } as any)

const AuthWithProjectLoginHistoryRoute =
  AuthWithProjectLoginHistoryImport.update({
    id: '/login-history',
    path: '/login-history',
    getParentRoute: () => AuthWithProjectRoute,
  } as any)

const AuthWithProjectInstructionsRoute =
  AuthWithProjectInstructionsImport.update({
    id: '/instructions',
    path: '/instructions',
    getParentRoute: () => AuthWithProjectRoute,
  } as any)

const AuthWithProjectDepartmentsRoute = AuthWithProjectDepartmentsImport.update(
  {
    id: '/departments',
    path: '/departments',
    getParentRoute: () => AuthWithProjectRoute,
  } as any,
)

const AuthWithProjectCompletedPatrolsRoute =
  AuthWithProjectCompletedPatrolsImport.update({
    id: '/completed-patrols',
    path: '/completed-patrols',
    getParentRoute: () => AuthWithProjectRoute,
  } as any)

const AuthWithProjectProjectDetailProjectIdRoute =
  AuthWithProjectProjectDetailProjectIdImport.update({
    id: '/project-detail/$projectId',
    path: '/project-detail/$projectId',
    getParentRoute: () => AuthWithProjectRoute,
  } as any)

const AuthWithProjectDocumentsSplatRoute =
  AuthWithProjectDocumentsSplatImport.update({
    id: '/documents/$',
    path: '/documents/$',
    getParentRoute: () => AuthWithProjectRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_unauth': {
      id: '/_unauth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthImport
      parentRoute: typeof rootRoute
    }
    '/_auth/_withProject': {
      id: '/_auth/_withProject'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthWithProjectImport
      parentRoute: typeof AuthImport
    }
    '/_auth/all-users': {
      id: '/_auth/all-users'
      path: '/all-users'
      fullPath: '/all-users'
      preLoaderRoute: typeof AuthAllUsersImport
      parentRoute: typeof AuthImport
    }
    '/_auth/onlyoffice': {
      id: '/_auth/onlyoffice'
      path: '/onlyoffice'
      fullPath: '/onlyoffice'
      preLoaderRoute: typeof AuthOnlyofficeImport
      parentRoute: typeof AuthImport
    }
    '/_auth/project-select': {
      id: '/_auth/project-select'
      path: '/project-select'
      fullPath: '/project-select'
      preLoaderRoute: typeof AuthProjectSelectImport
      parentRoute: typeof AuthImport
    }
    '/_unauth/create-password': {
      id: '/_unauth/create-password'
      path: '/create-password'
      fullPath: '/create-password'
      preLoaderRoute: typeof UnauthCreatePasswordImport
      parentRoute: typeof UnauthImport
    }
    '/_unauth/forgot-password': {
      id: '/_unauth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof UnauthForgotPasswordImport
      parentRoute: typeof UnauthImport
    }
    '/_unauth/login': {
      id: '/_unauth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthLoginImport
      parentRoute: typeof UnauthImport
    }
    '/_unauth/privacy-policy': {
      id: '/_unauth/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof UnauthPrivacyPolicyImport
      parentRoute: typeof UnauthImport
    }
    '/_unauth/reset-password': {
      id: '/_unauth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof UnauthResetPasswordImport
      parentRoute: typeof UnauthImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/_withProject/completed-patrols': {
      id: '/_auth/_withProject/completed-patrols'
      path: '/completed-patrols'
      fullPath: '/completed-patrols'
      preLoaderRoute: typeof AuthWithProjectCompletedPatrolsImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/departments': {
      id: '/_auth/_withProject/departments'
      path: '/departments'
      fullPath: '/departments'
      preLoaderRoute: typeof AuthWithProjectDepartmentsImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/instructions': {
      id: '/_auth/_withProject/instructions'
      path: '/instructions'
      fullPath: '/instructions'
      preLoaderRoute: typeof AuthWithProjectInstructionsImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/login-history': {
      id: '/_auth/_withProject/login-history'
      path: '/login-history'
      fullPath: '/login-history'
      preLoaderRoute: typeof AuthWithProjectLoginHistoryImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/no-permissions': {
      id: '/_auth/_withProject/no-permissions'
      path: '/no-permissions'
      fullPath: '/no-permissions'
      preLoaderRoute: typeof AuthWithProjectNoPermissionsImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/patrol-plans': {
      id: '/_auth/_withProject/patrol-plans'
      path: '/patrol-plans'
      fullPath: '/patrol-plans'
      preLoaderRoute: typeof AuthWithProjectPatrolPlansImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/patrol-report': {
      id: '/_auth/_withProject/patrol-report'
      path: '/patrol-report'
      fullPath: '/patrol-report'
      preLoaderRoute: typeof AuthWithProjectPatrolReportImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/patrol-routes': {
      id: '/_auth/_withProject/patrol-routes'
      path: '/patrol-routes'
      fullPath: '/patrol-routes'
      preLoaderRoute: typeof AuthWithProjectPatrolRoutesImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/payroll-slip': {
      id: '/_auth/_withProject/payroll-slip'
      path: '/payroll-slip'
      fullPath: '/payroll-slip'
      preLoaderRoute: typeof AuthWithProjectPayrollSlipImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/positions': {
      id: '/_auth/_withProject/positions'
      path: '/positions'
      fullPath: '/positions'
      preLoaderRoute: typeof AuthWithProjectPositionsImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/project-documents': {
      id: '/_auth/_withProject/project-documents'
      path: '/project-documents'
      fullPath: '/project-documents'
      preLoaderRoute: typeof AuthWithProjectProjectDocumentsImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/projects': {
      id: '/_auth/_withProject/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AuthWithProjectProjectsImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/reportDetail': {
      id: '/_auth/_withProject/reportDetail'
      path: '/reportDetail'
      fullPath: '/reportDetail'
      preLoaderRoute: typeof AuthWithProjectReportDetailImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/request-module': {
      id: '/_auth/_withProject/request-module'
      path: '/request-module'
      fullPath: '/request-module'
      preLoaderRoute: typeof AuthWithProjectRequestModuleImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/roles': {
      id: '/_auth/_withProject/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof AuthWithProjectRolesImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/roles-history': {
      id: '/_auth/_withProject/roles-history'
      path: '/roles-history'
      fullPath: '/roles-history'
      preLoaderRoute: typeof AuthWithProjectRolesHistoryImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/scorecard': {
      id: '/_auth/_withProject/scorecard'
      path: '/scorecard'
      fullPath: '/scorecard'
      preLoaderRoute: typeof AuthWithProjectScorecardImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/scorecard-logs': {
      id: '/_auth/_withProject/scorecard-logs'
      path: '/scorecard-logs'
      fullPath: '/scorecard-logs'
      preLoaderRoute: typeof AuthWithProjectScorecardLogsImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/shift-reports': {
      id: '/_auth/_withProject/shift-reports'
      path: '/shift-reports'
      fullPath: '/shift-reports'
      preLoaderRoute: typeof AuthWithProjectShiftReportsImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/shifts': {
      id: '/_auth/_withProject/shifts'
      path: '/shifts'
      fullPath: '/shifts'
      preLoaderRoute: typeof AuthWithProjectShiftsImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/users': {
      id: '/_auth/_withProject/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthWithProjectUsersImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/documents/$': {
      id: '/_auth/_withProject/documents/$'
      path: '/documents/$'
      fullPath: '/documents/$'
      preLoaderRoute: typeof AuthWithProjectDocumentsSplatImport
      parentRoute: typeof AuthWithProjectImport
    }
    '/_auth/_withProject/project-detail/$projectId': {
      id: '/_auth/_withProject/project-detail/$projectId'
      path: '/project-detail/$projectId'
      fullPath: '/project-detail/$projectId'
      preLoaderRoute: typeof AuthWithProjectProjectDetailProjectIdImport
      parentRoute: typeof AuthWithProjectImport
    }
  }
}

// Create and export the route tree

interface AuthWithProjectRouteChildren {
  AuthWithProjectCompletedPatrolsRoute: typeof AuthWithProjectCompletedPatrolsRoute
  AuthWithProjectDepartmentsRoute: typeof AuthWithProjectDepartmentsRoute
  AuthWithProjectInstructionsRoute: typeof AuthWithProjectInstructionsRoute
  AuthWithProjectLoginHistoryRoute: typeof AuthWithProjectLoginHistoryRoute
  AuthWithProjectNoPermissionsRoute: typeof AuthWithProjectNoPermissionsRoute
  AuthWithProjectPatrolPlansRoute: typeof AuthWithProjectPatrolPlansRoute
  AuthWithProjectPatrolReportRoute: typeof AuthWithProjectPatrolReportRoute
  AuthWithProjectPatrolRoutesRoute: typeof AuthWithProjectPatrolRoutesRoute
  AuthWithProjectPayrollSlipRoute: typeof AuthWithProjectPayrollSlipRoute
  AuthWithProjectPositionsRoute: typeof AuthWithProjectPositionsRoute
  AuthWithProjectProjectDocumentsRoute: typeof AuthWithProjectProjectDocumentsRoute
  AuthWithProjectProjectsRoute: typeof AuthWithProjectProjectsRoute
  AuthWithProjectReportDetailRoute: typeof AuthWithProjectReportDetailRoute
  AuthWithProjectRequestModuleRoute: typeof AuthWithProjectRequestModuleRoute
  AuthWithProjectRolesRoute: typeof AuthWithProjectRolesRoute
  AuthWithProjectRolesHistoryRoute: typeof AuthWithProjectRolesHistoryRoute
  AuthWithProjectScorecardRoute: typeof AuthWithProjectScorecardRoute
  AuthWithProjectScorecardLogsRoute: typeof AuthWithProjectScorecardLogsRoute
  AuthWithProjectShiftReportsRoute: typeof AuthWithProjectShiftReportsRoute
  AuthWithProjectShiftsRoute: typeof AuthWithProjectShiftsRoute
  AuthWithProjectUsersRoute: typeof AuthWithProjectUsersRoute
  AuthWithProjectDocumentsSplatRoute: typeof AuthWithProjectDocumentsSplatRoute
  AuthWithProjectProjectDetailProjectIdRoute: typeof AuthWithProjectProjectDetailProjectIdRoute
}

const AuthWithProjectRouteChildren: AuthWithProjectRouteChildren = {
  AuthWithProjectCompletedPatrolsRoute: AuthWithProjectCompletedPatrolsRoute,
  AuthWithProjectDepartmentsRoute: AuthWithProjectDepartmentsRoute,
  AuthWithProjectInstructionsRoute: AuthWithProjectInstructionsRoute,
  AuthWithProjectLoginHistoryRoute: AuthWithProjectLoginHistoryRoute,
  AuthWithProjectNoPermissionsRoute: AuthWithProjectNoPermissionsRoute,
  AuthWithProjectPatrolPlansRoute: AuthWithProjectPatrolPlansRoute,
  AuthWithProjectPatrolReportRoute: AuthWithProjectPatrolReportRoute,
  AuthWithProjectPatrolRoutesRoute: AuthWithProjectPatrolRoutesRoute,
  AuthWithProjectPayrollSlipRoute: AuthWithProjectPayrollSlipRoute,
  AuthWithProjectPositionsRoute: AuthWithProjectPositionsRoute,
  AuthWithProjectProjectDocumentsRoute: AuthWithProjectProjectDocumentsRoute,
  AuthWithProjectProjectsRoute: AuthWithProjectProjectsRoute,
  AuthWithProjectReportDetailRoute: AuthWithProjectReportDetailRoute,
  AuthWithProjectRequestModuleRoute: AuthWithProjectRequestModuleRoute,
  AuthWithProjectRolesRoute: AuthWithProjectRolesRoute,
  AuthWithProjectRolesHistoryRoute: AuthWithProjectRolesHistoryRoute,
  AuthWithProjectScorecardRoute: AuthWithProjectScorecardRoute,
  AuthWithProjectScorecardLogsRoute: AuthWithProjectScorecardLogsRoute,
  AuthWithProjectShiftReportsRoute: AuthWithProjectShiftReportsRoute,
  AuthWithProjectShiftsRoute: AuthWithProjectShiftsRoute,
  AuthWithProjectUsersRoute: AuthWithProjectUsersRoute,
  AuthWithProjectDocumentsSplatRoute: AuthWithProjectDocumentsSplatRoute,
  AuthWithProjectProjectDetailProjectIdRoute:
    AuthWithProjectProjectDetailProjectIdRoute,
}

const AuthWithProjectRouteWithChildren = AuthWithProjectRoute._addFileChildren(
  AuthWithProjectRouteChildren,
)

interface AuthRouteChildren {
  AuthWithProjectRoute: typeof AuthWithProjectRouteWithChildren
  AuthAllUsersRoute: typeof AuthAllUsersRoute
  AuthOnlyofficeRoute: typeof AuthOnlyofficeRoute
  AuthProjectSelectRoute: typeof AuthProjectSelectRoute
  AuthIndexRoute: typeof AuthIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthWithProjectRoute: AuthWithProjectRouteWithChildren,
  AuthAllUsersRoute: AuthAllUsersRoute,
  AuthOnlyofficeRoute: AuthOnlyofficeRoute,
  AuthProjectSelectRoute: AuthProjectSelectRoute,
  AuthIndexRoute: AuthIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface UnauthRouteChildren {
  UnauthCreatePasswordRoute: typeof UnauthCreatePasswordRoute
  UnauthForgotPasswordRoute: typeof UnauthForgotPasswordRoute
  UnauthLoginRoute: typeof UnauthLoginRoute
  UnauthPrivacyPolicyRoute: typeof UnauthPrivacyPolicyRoute
  UnauthResetPasswordRoute: typeof UnauthResetPasswordRoute
}

const UnauthRouteChildren: UnauthRouteChildren = {
  UnauthCreatePasswordRoute: UnauthCreatePasswordRoute,
  UnauthForgotPasswordRoute: UnauthForgotPasswordRoute,
  UnauthLoginRoute: UnauthLoginRoute,
  UnauthPrivacyPolicyRoute: UnauthPrivacyPolicyRoute,
  UnauthResetPasswordRoute: UnauthResetPasswordRoute,
}

const UnauthRouteWithChildren =
  UnauthRoute._addFileChildren(UnauthRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AuthWithProjectRouteWithChildren
  '/all-users': typeof AuthAllUsersRoute
  '/onlyoffice': typeof AuthOnlyofficeRoute
  '/project-select': typeof AuthProjectSelectRoute
  '/create-password': typeof UnauthCreatePasswordRoute
  '/forgot-password': typeof UnauthForgotPasswordRoute
  '/login': typeof UnauthLoginRoute
  '/privacy-policy': typeof UnauthPrivacyPolicyRoute
  '/reset-password': typeof UnauthResetPasswordRoute
  '/': typeof AuthIndexRoute
  '/completed-patrols': typeof AuthWithProjectCompletedPatrolsRoute
  '/departments': typeof AuthWithProjectDepartmentsRoute
  '/instructions': typeof AuthWithProjectInstructionsRoute
  '/login-history': typeof AuthWithProjectLoginHistoryRoute
  '/no-permissions': typeof AuthWithProjectNoPermissionsRoute
  '/patrol-plans': typeof AuthWithProjectPatrolPlansRoute
  '/patrol-report': typeof AuthWithProjectPatrolReportRoute
  '/patrol-routes': typeof AuthWithProjectPatrolRoutesRoute
  '/payroll-slip': typeof AuthWithProjectPayrollSlipRoute
  '/positions': typeof AuthWithProjectPositionsRoute
  '/project-documents': typeof AuthWithProjectProjectDocumentsRoute
  '/projects': typeof AuthWithProjectProjectsRoute
  '/reportDetail': typeof AuthWithProjectReportDetailRoute
  '/request-module': typeof AuthWithProjectRequestModuleRoute
  '/roles': typeof AuthWithProjectRolesRoute
  '/roles-history': typeof AuthWithProjectRolesHistoryRoute
  '/scorecard': typeof AuthWithProjectScorecardRoute
  '/scorecard-logs': typeof AuthWithProjectScorecardLogsRoute
  '/shift-reports': typeof AuthWithProjectShiftReportsRoute
  '/shifts': typeof AuthWithProjectShiftsRoute
  '/users': typeof AuthWithProjectUsersRoute
  '/documents/$': typeof AuthWithProjectDocumentsSplatRoute
  '/project-detail/$projectId': typeof AuthWithProjectProjectDetailProjectIdRoute
}

export interface FileRoutesByTo {
  '': typeof AuthWithProjectRouteWithChildren
  '/all-users': typeof AuthAllUsersRoute
  '/onlyoffice': typeof AuthOnlyofficeRoute
  '/project-select': typeof AuthProjectSelectRoute
  '/create-password': typeof UnauthCreatePasswordRoute
  '/forgot-password': typeof UnauthForgotPasswordRoute
  '/login': typeof UnauthLoginRoute
  '/privacy-policy': typeof UnauthPrivacyPolicyRoute
  '/reset-password': typeof UnauthResetPasswordRoute
  '/': typeof AuthIndexRoute
  '/completed-patrols': typeof AuthWithProjectCompletedPatrolsRoute
  '/departments': typeof AuthWithProjectDepartmentsRoute
  '/instructions': typeof AuthWithProjectInstructionsRoute
  '/login-history': typeof AuthWithProjectLoginHistoryRoute
  '/no-permissions': typeof AuthWithProjectNoPermissionsRoute
  '/patrol-plans': typeof AuthWithProjectPatrolPlansRoute
  '/patrol-report': typeof AuthWithProjectPatrolReportRoute
  '/patrol-routes': typeof AuthWithProjectPatrolRoutesRoute
  '/payroll-slip': typeof AuthWithProjectPayrollSlipRoute
  '/positions': typeof AuthWithProjectPositionsRoute
  '/project-documents': typeof AuthWithProjectProjectDocumentsRoute
  '/projects': typeof AuthWithProjectProjectsRoute
  '/reportDetail': typeof AuthWithProjectReportDetailRoute
  '/request-module': typeof AuthWithProjectRequestModuleRoute
  '/roles': typeof AuthWithProjectRolesRoute
  '/roles-history': typeof AuthWithProjectRolesHistoryRoute
  '/scorecard': typeof AuthWithProjectScorecardRoute
  '/scorecard-logs': typeof AuthWithProjectScorecardLogsRoute
  '/shift-reports': typeof AuthWithProjectShiftReportsRoute
  '/shifts': typeof AuthWithProjectShiftsRoute
  '/users': typeof AuthWithProjectUsersRoute
  '/documents/$': typeof AuthWithProjectDocumentsSplatRoute
  '/project-detail/$projectId': typeof AuthWithProjectProjectDetailProjectIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_unauth': typeof UnauthRouteWithChildren
  '/_auth/_withProject': typeof AuthWithProjectRouteWithChildren
  '/_auth/all-users': typeof AuthAllUsersRoute
  '/_auth/onlyoffice': typeof AuthOnlyofficeRoute
  '/_auth/project-select': typeof AuthProjectSelectRoute
  '/_unauth/create-password': typeof UnauthCreatePasswordRoute
  '/_unauth/forgot-password': typeof UnauthForgotPasswordRoute
  '/_unauth/login': typeof UnauthLoginRoute
  '/_unauth/privacy-policy': typeof UnauthPrivacyPolicyRoute
  '/_unauth/reset-password': typeof UnauthResetPasswordRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/_withProject/completed-patrols': typeof AuthWithProjectCompletedPatrolsRoute
  '/_auth/_withProject/departments': typeof AuthWithProjectDepartmentsRoute
  '/_auth/_withProject/instructions': typeof AuthWithProjectInstructionsRoute
  '/_auth/_withProject/login-history': typeof AuthWithProjectLoginHistoryRoute
  '/_auth/_withProject/no-permissions': typeof AuthWithProjectNoPermissionsRoute
  '/_auth/_withProject/patrol-plans': typeof AuthWithProjectPatrolPlansRoute
  '/_auth/_withProject/patrol-report': typeof AuthWithProjectPatrolReportRoute
  '/_auth/_withProject/patrol-routes': typeof AuthWithProjectPatrolRoutesRoute
  '/_auth/_withProject/payroll-slip': typeof AuthWithProjectPayrollSlipRoute
  '/_auth/_withProject/positions': typeof AuthWithProjectPositionsRoute
  '/_auth/_withProject/project-documents': typeof AuthWithProjectProjectDocumentsRoute
  '/_auth/_withProject/projects': typeof AuthWithProjectProjectsRoute
  '/_auth/_withProject/reportDetail': typeof AuthWithProjectReportDetailRoute
  '/_auth/_withProject/request-module': typeof AuthWithProjectRequestModuleRoute
  '/_auth/_withProject/roles': typeof AuthWithProjectRolesRoute
  '/_auth/_withProject/roles-history': typeof AuthWithProjectRolesHistoryRoute
  '/_auth/_withProject/scorecard': typeof AuthWithProjectScorecardRoute
  '/_auth/_withProject/scorecard-logs': typeof AuthWithProjectScorecardLogsRoute
  '/_auth/_withProject/shift-reports': typeof AuthWithProjectShiftReportsRoute
  '/_auth/_withProject/shifts': typeof AuthWithProjectShiftsRoute
  '/_auth/_withProject/users': typeof AuthWithProjectUsersRoute
  '/_auth/_withProject/documents/$': typeof AuthWithProjectDocumentsSplatRoute
  '/_auth/_withProject/project-detail/$projectId': typeof AuthWithProjectProjectDetailProjectIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/all-users'
    | '/onlyoffice'
    | '/project-select'
    | '/create-password'
    | '/forgot-password'
    | '/login'
    | '/privacy-policy'
    | '/reset-password'
    | '/'
    | '/completed-patrols'
    | '/departments'
    | '/instructions'
    | '/login-history'
    | '/no-permissions'
    | '/patrol-plans'
    | '/patrol-report'
    | '/patrol-routes'
    | '/payroll-slip'
    | '/positions'
    | '/project-documents'
    | '/projects'
    | '/reportDetail'
    | '/request-module'
    | '/roles'
    | '/roles-history'
    | '/scorecard'
    | '/scorecard-logs'
    | '/shift-reports'
    | '/shifts'
    | '/users'
    | '/documents/$'
    | '/project-detail/$projectId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/all-users'
    | '/onlyoffice'
    | '/project-select'
    | '/create-password'
    | '/forgot-password'
    | '/login'
    | '/privacy-policy'
    | '/reset-password'
    | '/'
    | '/completed-patrols'
    | '/departments'
    | '/instructions'
    | '/login-history'
    | '/no-permissions'
    | '/patrol-plans'
    | '/patrol-report'
    | '/patrol-routes'
    | '/payroll-slip'
    | '/positions'
    | '/project-documents'
    | '/projects'
    | '/reportDetail'
    | '/request-module'
    | '/roles'
    | '/roles-history'
    | '/scorecard'
    | '/scorecard-logs'
    | '/shift-reports'
    | '/shifts'
    | '/users'
    | '/documents/$'
    | '/project-detail/$projectId'
  id:
    | '__root__'
    | '/_auth'
    | '/_unauth'
    | '/_auth/_withProject'
    | '/_auth/all-users'
    | '/_auth/onlyoffice'
    | '/_auth/project-select'
    | '/_unauth/create-password'
    | '/_unauth/forgot-password'
    | '/_unauth/login'
    | '/_unauth/privacy-policy'
    | '/_unauth/reset-password'
    | '/_auth/'
    | '/_auth/_withProject/completed-patrols'
    | '/_auth/_withProject/departments'
    | '/_auth/_withProject/instructions'
    | '/_auth/_withProject/login-history'
    | '/_auth/_withProject/no-permissions'
    | '/_auth/_withProject/patrol-plans'
    | '/_auth/_withProject/patrol-report'
    | '/_auth/_withProject/patrol-routes'
    | '/_auth/_withProject/payroll-slip'
    | '/_auth/_withProject/positions'
    | '/_auth/_withProject/project-documents'
    | '/_auth/_withProject/projects'
    | '/_auth/_withProject/reportDetail'
    | '/_auth/_withProject/request-module'
    | '/_auth/_withProject/roles'
    | '/_auth/_withProject/roles-history'
    | '/_auth/_withProject/scorecard'
    | '/_auth/_withProject/scorecard-logs'
    | '/_auth/_withProject/shift-reports'
    | '/_auth/_withProject/shifts'
    | '/_auth/_withProject/users'
    | '/_auth/_withProject/documents/$'
    | '/_auth/_withProject/project-detail/$projectId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  UnauthRoute: typeof UnauthRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  UnauthRoute: UnauthRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth",
        "/_unauth"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/_withProject",
        "/_auth/all-users",
        "/_auth/onlyoffice",
        "/_auth/project-select",
        "/_auth/"
      ]
    },
    "/_unauth": {
      "filePath": "_unauth.tsx",
      "children": [
        "/_unauth/create-password",
        "/_unauth/forgot-password",
        "/_unauth/login",
        "/_unauth/privacy-policy",
        "/_unauth/reset-password"
      ]
    },
    "/_auth/_withProject": {
      "filePath": "_auth/_withProject.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/_withProject/completed-patrols",
        "/_auth/_withProject/departments",
        "/_auth/_withProject/instructions",
        "/_auth/_withProject/login-history",
        "/_auth/_withProject/no-permissions",
        "/_auth/_withProject/patrol-plans",
        "/_auth/_withProject/patrol-report",
        "/_auth/_withProject/patrol-routes",
        "/_auth/_withProject/payroll-slip",
        "/_auth/_withProject/positions",
        "/_auth/_withProject/project-documents",
        "/_auth/_withProject/projects",
        "/_auth/_withProject/reportDetail",
        "/_auth/_withProject/request-module",
        "/_auth/_withProject/roles",
        "/_auth/_withProject/roles-history",
        "/_auth/_withProject/scorecard",
        "/_auth/_withProject/scorecard-logs",
        "/_auth/_withProject/shift-reports",
        "/_auth/_withProject/shifts",
        "/_auth/_withProject/users",
        "/_auth/_withProject/documents/$",
        "/_auth/_withProject/project-detail/$projectId"
      ]
    },
    "/_auth/all-users": {
      "filePath": "_auth/all-users.tsx",
      "parent": "/_auth"
    },
    "/_auth/onlyoffice": {
      "filePath": "_auth/onlyoffice.tsx",
      "parent": "/_auth"
    },
    "/_auth/project-select": {
      "filePath": "_auth/project-select.tsx",
      "parent": "/_auth"
    },
    "/_unauth/create-password": {
      "filePath": "_unauth/create-password.tsx",
      "parent": "/_unauth"
    },
    "/_unauth/forgot-password": {
      "filePath": "_unauth/forgot-password.tsx",
      "parent": "/_unauth"
    },
    "/_unauth/login": {
      "filePath": "_unauth/login.tsx",
      "parent": "/_unauth"
    },
    "/_unauth/privacy-policy": {
      "filePath": "_unauth/privacy-policy.tsx",
      "parent": "/_unauth"
    },
    "/_unauth/reset-password": {
      "filePath": "_unauth/reset-password.tsx",
      "parent": "/_unauth"
    },
    "/_auth/": {
      "filePath": "_auth/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/_withProject/completed-patrols": {
      "filePath": "_auth/_withProject/completed-patrols.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/departments": {
      "filePath": "_auth/_withProject/departments.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/instructions": {
      "filePath": "_auth/_withProject/instructions.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/login-history": {
      "filePath": "_auth/_withProject/login-history.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/no-permissions": {
      "filePath": "_auth/_withProject/no-permissions.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/patrol-plans": {
      "filePath": "_auth/_withProject/patrol-plans.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/patrol-report": {
      "filePath": "_auth/_withProject/patrol-report.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/patrol-routes": {
      "filePath": "_auth/_withProject/patrol-routes.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/payroll-slip": {
      "filePath": "_auth/_withProject/payroll-slip.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/positions": {
      "filePath": "_auth/_withProject/positions.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/project-documents": {
      "filePath": "_auth/_withProject/project-documents.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/projects": {
      "filePath": "_auth/_withProject/projects.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/reportDetail": {
      "filePath": "_auth/_withProject/reportDetail.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/request-module": {
      "filePath": "_auth/_withProject/request-module.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/roles": {
      "filePath": "_auth/_withProject/roles.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/roles-history": {
      "filePath": "_auth/_withProject/roles-history.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/scorecard": {
      "filePath": "_auth/_withProject/scorecard.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/scorecard-logs": {
      "filePath": "_auth/_withProject/scorecard-logs.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/shift-reports": {
      "filePath": "_auth/_withProject/shift-reports.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/shifts": {
      "filePath": "_auth/_withProject/shifts.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/users": {
      "filePath": "_auth/_withProject/users.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/documents/$": {
      "filePath": "_auth/_withProject/documents.$.tsx",
      "parent": "/_auth/_withProject"
    },
    "/_auth/_withProject/project-detail/$projectId": {
      "filePath": "_auth/_withProject/project-detail.$projectId.tsx",
      "parent": "/_auth/_withProject"
    }
  }
}
ROUTE_MANIFEST_END */
